import {
  black1,
  green,
  greenDefault,
  grey10,
  grey13Opacity60,
  grey9,
  yellow1,
} from 'app/components/ThemeProvider/colors';
import { MenuItem, SxProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export const btnStatusPayment: SxProps = {
  display: 'flex',
  gap: '8px',
  p: '12px 16px',
  background: 'transparent',
  '&:hover': { background: grey10 },
};
export const tableRowStyle: SxProps = {
  border: 'none',
  // display: 'flex',
  // justifyContent: 'space-between',
  // p: '0 28px',
  // gap: '15px',
  // fontSize: '16px',
  // fontWeight: '500 !important',
};

export const tableCell: SxProps = {
  p: '15px',
  paddingLeft: '32px',
  border: 'none',
};

export const tableCellStatus: SxProps = {
  p: '21px 0',
  border: 'none',
  display: 'flex',
  gap: '15px',
  alignItems: 'center',
  width: '185px',
};

export const notif: SxProps = {
  background: yellow1,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  width: '20px',
  height: '20px',
};

export const notifText: SxProps = {
  fontSize: '12px',
  fontWeight: '700',
  fontFamily: 'Yelo',
};

export const CustomMenuItem = styled(MenuItem)<{
  disableHover?: boolean;
}>(({ disableHover = false }) => ({
  color: disableHover ? green : black1,
  display: 'flex',
  gap: '12px',
  fontSize: '15px',
  fontFamily: 'Yelo',
  padding: '12px 16px',
  '&:hover': {
    color: !disableHover ? `${black1} !important` : green,
    background: `${grey9} !important`,
  },
}));

export const menuItems: SxProps = {
  color: black1,
  display: 'flex',
  gap: '12px',
  fontSize: '15px',
  fontFamily: 'Yelo',
  p: '12px 16px',

  '&:hover': {
    color: `${black1} !important`,
    background: `${grey9} !important`,
  },
};

export const pagination: SxProps = {
  mt: '28px',
  '& .MuiPaginationItem-rounded, .MuiPaginationItem-previousNext': {
    borderRadius: '8px !important',
    width: '32px !important',
    height: '32px !important',
    background: 'white !important',
    borderColor: 'rgba(20, 25, 31, 0.10)',
    color: `${black1} !important`,
    fontWeight: '700 !important',
    fontFamily: 'Yelo',
  },

  '& ul li:first-of-type': {
    marginRight: '0',
  },

  '& ul li:last-of-type': {
    marginLeft: '0',
  },

  '& .Mui-disabled': {
    background: 'rgba(20, 25, 31, 0.10) !important',
  },

  '& .Mui-selected': {
    borderColor: black1,
  },
};

export const tableHeaderCell: SxProps = {
  // p: '21px 0',
  border: 'none',
  // display: 'flex',
  // flexDirection: 'column',
  // gap: '4px',
  // justifyContent: 'center',
  // wordWrap: 'break-word',
};

export const secondaryText: SxProps = {
  fontSize: '14px',
  color: grey13Opacity60,
};

export const amountText: SxProps = {
  fontSize: '16x',
  color: greenDefault,
};
